import { IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';
import { SubscribableService } from '@src/slide/application/service/subscribable-service';
import { ISelectedByOtherInfo } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ReactElement } from 'react';

export interface ICursorManager extends SubscribableService<CursorManagerEventMap> {
    elementsWithCursors: IElementWithCursor[];
    historyManager?: IHistoryManager;
    renderCursorTags(props?: Partial<ICursorTagsProps>): ReactElement;
    showCursorTagForElement(element: IElementBaseModel): void;
    hideCursorTagForElement(element: IElementBaseModel): void;
    clearCursorTagsForElements(elements?: IElementBaseModel[]): void;
    isElementInSlide(element: IElementBaseModel): boolean;
}

export interface ICursorManagerInjectable {
    // define injectables here
}

export interface IElementWithCursor {
    id: string;
    element: IElementBaseModel;
    cursor: ISelectedByOtherInfo[];
}

export enum CursorManagerEventType {
    SHOW = 'show',
    HIDE = 'hide',
    REFRESH = 'refresh',
    CLEAR = 'clear',
}

export interface ICursorTagsProps {
    scale: number;
    top: number;
    left: number;
    cursorManager: ICursorManager;
}

export interface ICursorManagerShowEventPayload {
    key: string | undefined;
    position: { x: number, y: number };
    cursor: ISelectedByOtherInfo | undefined;
}

export interface ICursorManagerHideEventPayload {
    key: string | undefined;
}

export interface ICursorManagerRefreshEventPayload {
    show: ICursorManagerShowEventPayload[];
    hide: ICursorManagerHideEventPayload[];
}

export interface CursorManagerEventMap {
    [CursorManagerEventType.SHOW]: ICursorManagerShowEventPayload;
    [CursorManagerEventType.HIDE]: ICursorManagerHideEventPayload;
    [CursorManagerEventType.REFRESH]: ICursorManagerRefreshEventPayload;
    [CursorManagerEventType.CLEAR]: { keys: Array<string | undefined> };
}

